<template>
    <div class="font-main-regular" v-if=trackingInit>
        <router-view :key="$route.path" />
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";

export default {
    data: function() {
        return {
            trackingInit: false,
        };
    },
    created: function() {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
    },
    methods: {
        onTrackingInit: function () {
            this.trackingInit = true;
        },
    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
    },
}
</script>
<style lang="scss">
    @import "./style/base/base.scss";
    @import "./style/main.scss";
</style>
